<template>
  <button :class="props.class">
    <ChatBubbleOvalLeftIcon class="w-6 h-6" />
    <div>{{ showCounter ? selectedPin?.comment_id.length : '' }}</div>
  </button>
</template>

<script setup lang="ts">
import { usePinsStore } from '@/stores/pins'
import { ChatBubbleOvalLeftIcon } from '@heroicons/vue/24/outline'
import { storeToRefs } from 'pinia'

const pinsStore = usePinsStore()
const { selectedPin } = storeToRefs(pinsStore)

defineEmits<{
  (e: 'like'): void
}>()

export interface CommentButtonProps {
  class?: string
  showCounter?: boolean
}

const props = withDefaults(defineProps<CommentButtonProps>(), {
  class: 'btn btn-ghost text-accent flex flex-row',
  showCounter: false
})
</script>
